import React from "react";
import '../commanComponents.css'

export default function BorderButton({ text, onClick, icon, style, isActive }) {
  return (
    <button className={isActive? "activeBorderButton" :'borderButton'} onClick={onClick} style={style}>
      <div>{icon}</div>{text}
    </button>
  );
}
